/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader} from '../../../../../../../components/UI'
import {FC, useEffect, useCallback, useMemo} from 'react'
import {OptionByProfileModel} from '../../../../../model'
interface Props {
  rowData: any[]
  getDataPermission?: (e: any) => void
}
const ColumnTable: FC<Props> = ({rowData, getDataPermission = () => {}}) => {
  const {data, setData} = useKTable()

  useEffect(() => {
    setData(rowData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData])
  const handleCheckboxChange = useCallback(
    (rowIndex: number) => {
      setData((prevData: any[]) => {
        let newData = [...prevData]
        newData[rowIndex] = {...newData[rowIndex], flagActions: !newData[rowIndex].flagActions}
        // newData[rowIndex].flagActions = !newData[rowIndex].flagActions
        getDataPermission(newData[rowIndex])
        return newData
      })

      // Llamar a la función adicional aquí
    },
    [setData],
  )
  const columns: Column<OptionByProfileModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Permiso' />,
        accessor: 'opcion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Activo' />,
        id: 'actions1',
        Cell: ({...props}) => (
          <div className='d-flex justify-content-center flex-shrink-0'>
            {/* <div className='sdx_form_input '> */}
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                checked={props.data[props.row.index].flagActions}
                onChange={() => handleCheckboxChange(props.row.index)}
              />
            </div>
            {/* </div> */}
          </div>
        ),
      },
    ],
    [data],
  )

  return (
    <div className='mx-2'>
      <KTable
        data={data}
        columns={columns}
        classNameProps='dataTablecentral'
        showPagination={false}
      />
    </div>
  )
}

const ColumnTableWrapper: FC<Props> = ({rowData, getDataPermission}) => {
  return (
    <KTableProvider>
      <ColumnTable rowData={rowData} getDataPermission={getDataPermission} />
    </KTableProvider>
  )
}
export {ColumnTableWrapper}
